import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import clasnames from 'classnames';

var TabsHeader = function (_React$Component) {
  _inherits(TabsHeader, _React$Component);

  var _super = _createSuper(TabsHeader);

  function TabsHeader() {
    var _this;

    _classCallCheck(this, TabsHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleTabClick = function (key) {
      return function () {
        if (_this.props.onTabClick) {
          _this.props.onTabClick(key);
        }
      };
    };

    return _this;
  }

  _createClass(TabsHeader, [{
    key: "renderItems",
    value: function renderItems() {
      var _this2 = this;

      var _this$props = this.props,
          items = _this$props.items,
          activeKey = _this$props.activeKey;

      var _renderItem = function _renderItem(_ref) {
        var key = _ref.key,
            title = _ref.title,
            hasError = _ref.hasError;
        var isActive = activeKey === key;

        var _classNames = clasnames('TabsHeader__item', {
          'TabsHeader__item--active': isActive,
          'TabsHeader__item--error': !!hasError
        });

        return React.createElement("li", {
          className: _classNames,
          key: key,
          role: "tab"
        }, React.createElement("button", {
          type: "button",
          onClick: _this2.handleTabClick(key),
          className: "TabsHeader__item-link"
        }, title));
      };

      return items.map(_renderItem);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        className: "TabsHeader"
      }, React.createElement("ul", {
        className: "TabsHeader__nav",
        role: "tablist"
      }, this.renderItems()));
    }
  }]);

  return TabsHeader;
}(React.Component);

TabsHeader.displayName = 'Tabs.Header';
TabsHeader.defaultProps = {
  activeKey: null,
  onTabClick: undefined
};
export default TabsHeader;